import { LANGUAGE } from '../constants';
import { Language } from '../types/common';
import type { OptionsType } from '../types/options';

/**
 * 区分オプションから区分名名を返す。該当する商社が見つからなかったら区分コードをそのまま帰す。
 * @param businessTypeCode [string]
 * @param businessTypes [OptionsType[]]
 * @param language? [Language]
 * @returns [string]
 */
const getBusinessTypeName = (businessTypeCode: string, businessTypes: OptionsType[], language?: Language): string => {
  // 商社の検索
  const businessType: OptionsType | undefined = businessTypes?.find((maker) => maker.code === businessTypeCode);
  const businessTypeName: string = businessType
    ? language
      ? language === LANGUAGE.EN
        ? businessType.nameEnglish
          ? businessType.nameEnglish
          : businessType.nameJapanese
        : businessType.nameJapanese
      : businessType.nameJapanese
    : businessTypeCode;
  return businessTypeName;
};

export default getBusinessTypeName;
